module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjQwIiBjeT0iNDAiIHI9IjM4LjUiIHN0cm9rZT0iIzRCNjlGRSIgc3Ryb2tlLXdpZHRoPSIzIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse108.svg
// module id = Ag0Q
// module chunks = 1